/**
 * Deployment environment of the running backend (#3312).
 *
 * `isTestEnvironment` is false until the answer arrives and on any error: the
 * marker is informational, and the actual protection — no outbound messages,
 * payments or e-invoices — is enforced server-side regardless.
 */

import { useEffect, useState } from 'react';
import { fetchPublicEnvironment, type DeploymentEnvironment } from '@/api/publicEnvironment';

export function useDeploymentEnvironment(): {
  environment: DeploymentEnvironment | null;
  isTestEnvironment: boolean;
} {
  const [environment, setEnvironment] = useState<DeploymentEnvironment | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchPublicEnvironment()
      .then((value) => {
        if (!cancelled) setEnvironment(value);
      })
      .catch(() => {
        // Unknown environment: show nothing rather than a wrong marker.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { environment, isTestEnvironment: environment === 'test' };
}
